module.exports = __webpack_public_path__ + "wallet.jpg?470e0943b3ab004d7508412b265f0ada";